import type { ArchetypeId } from "../types"

export const WRAPPING_SUMMARY = [
  "You’ve explored your aura — its colors, sensitivities, strengths, growth edges, and the ways your energy naturally moves through the world.",
  "Your aura isn’t a fixed definition. It’s a way to notice your patterns — what strengthens you, what drains you, and what helps you return to yourself. This report gives you a language for your energy. What you do with that awareness is yours.",
] as const

const MOONWELL_AFFIRMATION =
  "Feel deeply. Protect your energy. Trust what you sense. Your sensitivity is part of your strength."

export const ARCHETYPE_AFFIRMATION: Record<ArchetypeId, string> = {
  "wildfire-beacon": MOONWELL_AFFIRMATION,
  rootbinder: MOONWELL_AFFIRMATION,
  "skyline-voice": MOONWELL_AFFIRMATION,
  moonwell: MOONWELL_AFFIRMATION,
  "prism-hearth": MOONWELL_AFFIRMATION,
  "quiet-compass": MOONWELL_AFFIRMATION,
  nightbloom: MOONWELL_AFFIRMATION,
  "deep-current": MOONWELL_AFFIRMATION,
  northlight: MOONWELL_AFFIRMATION,
  "ember-weaver": MOONWELL_AFFIRMATION,
  stormrider: MOONWELL_AFFIRMATION,
  "tidal-guardian": MOONWELL_AFFIRMATION,
}

export const SENSITIVITY_LABELS = {
  natureAttunement: "Nature Attunement",
  energySensitivity: "Energy Sensitivity",
  intuitiveReception: "Intuitive Reception",
} as const

export const ADVISORS_COPY = {
  title: "Want to understand your aura on a deeper level?",
  body: "This report gives you a clear picture of your aura — its strengths, sensitivities, patterns, and growth edges. But some questions are easier to explore with personal guidance. How can I protect my energy in relationships? Why do certain places drain me? How can I work with my intuition without feeling overwhelmed?",
  closer:
    "Our trusted guides can explore your results with you and offer personal guidance for the areas that matter most to you.",
} as const
